<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/additional-inter-header.png')" class="page__header" />
    <div class="page__container">
      <table class="full-width mt-0">
        <tr class="primary-background">
          <th colspan="2" class="primary-background h1 color-white text-left pl-4 mb-0">
            Serv. Adic. CTT INTERNACIONAL EUROPA LIGHT
          </th>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_SEG_VOLUNTARIO') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR751').value }}% (min
            {{ getAdditionalServiceById('TR751').minValue }}<span class="euro-symbol">€</span>)
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_DELIVERY_NOTE') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR752').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_ENTREGA_ADICIONAL') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR753').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXC_PESO_25') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR754').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXC_PESO_50') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR755').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXC_DIM_100') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR756').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXC_DIM_120') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR757').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXC_DIM_175') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR758').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXC_DIM_SUM') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR759').value }}<span class="euro-symbol">€</span>/bulto
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_SPECIAL_HANDLING') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR760').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXC_ITEM') }}</td>
          <td class="body-2 text-center">
            Mínimo {{ getAdditionalServiceById('TR761').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_HIELO_SECO') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR762').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXC_HIELO_SECO') }}</td>
          <td class="body-2 text-center">
            <template v-if="Number(getAdditionalServiceById('TR763').value) === 0">
              Consultar
            </template>
            <template v-else>
              {{ getAdditionalServiceById('TR763').value }}<span class="euro-symbol">€</span>
            </template>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_AREAS_REMOTAS') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR764').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_SERVICIO_ISLAS') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR765').value }}<span class="euro-symbol">€</span>/kg
            (min {{ getAdditionalServiceById('TR765').minValue }}<span class="euro-symbol">€</span>)
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXP_FUERA_EU') }}</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('TR766').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_EXP_GB') }}</td>
          <td class="body-2 text-center">
            Cargo mínimo a Reino Unido de
            {{ getAdditionalServiceById('TR767').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_DUTY') }}</td>
          <td class="body-2 text-center">
            <template v-if="Number(getAdditionalServiceById('TR768').value) === 0">
              Consultar
            </template>
            <template v-else>
              {{ getAdditionalServiceById('TR768').value }}<span class="euro-symbol">€</span>
            </template>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('TX_CIEL_PEAK') }}</td>
          <td class="body-2 text-center">
            <template v-if="Number(getAdditionalServiceById('TR769').value) === 0">
              Consultar
            </template>
            <template v-else>
              {{ getAdditionalServiceById('TR769').value }}<span class="euro-symbol">€</span>
            </template>
          </td>
        </tr>
      </table>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-v2/Footer'

export default {
  name: 'AdditionalServicesInternationalCiel',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  methods: {
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('AdditionalServicesInternationalCiel')
  },
}
</script>
